// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.table-fixed {
  table-layout: fixed; /* 讓 colgroup 寬度生效 */
  width: 100%;
}

/* 長字避免撐破 */
.td-wrap, .table-fixed td, .table-fixed th {
  white-space: normal;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/pages/admeve/styles/admeve.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mBAAA,EAAA,oBAAA;EACA,WAAA;AAEF;;AACA,WAAA;AACA;EACE,mBAAA;EACA,sBAAA;AAEF","sourcesContent":[".table-fixed {\r\n  table-layout: fixed; /* 讓 colgroup 寬度生效 */\r\n  width: 100%;\r\n}\r\n\r\n/* 長字避免撐破 */\r\n.td-wrap, .table-fixed td, .table-fixed th {\r\n  white-space: normal;\r\n  word-break: break-word;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
